<template>
  <div class="help-content">
    <p class="duanluo">
      如果您对中国汽车材料数据系统注册及相关使用事宜等有任何疑问，请通过电话或者电子邮件与我们联系，我们对您所提出的任何意见和建议表示衷心的感谢。
      　　所有用户均可以利用如下联系方式，与客服中心联系合作并索取相关服务。
    </p>
    <div>
      <h4>客服中心</h4>
      <p>
        <span>周一至周五 8：30-12：00　13：30-17：00</span
        ><span class="right">技术客服：XXXXXXX</span>
      </p>
      <p>
        <span>传真：XXXXXXXXX</span><span>电子邮件：XXXXXX</span
        ><span class="right">地址：天津市西青区</span> 　　 　　
      </p>

      <p>邮编：300300 　　</p>
      　
      <h4>投诉建议中心</h4>
      <p>
        为了提高我们的服务和质量，我们为您提供服务投诉和建议的专用通道，如果您对我们的服务有什么意见或建议，您可以发送邮件给我们，我们将在收到您的投诉后24小时内处理。
      </p>
      <p>
        <span>电子邮件：XXXXXXX</span
        ><span class="right">地址：天津市西青区</span>
      </p>
      <P>邮编：300300</P>
      <P>
        如果您对中国汽车材料数据系统注册及相关使用事宜等有任何疑问，请通过电话或者电子邮件与我们联系，我们对您所提出的任何意见和建议表示衷心的感谢。</P
      >　　 　　 　　
      <P>所有用户均可以利用如下联系方式，与客服中心联系合作并索取相关服务。</P>
    </div>
    <div style="text-align: right">
      <el-button type="primary" @click="closeHelpDoc">关闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
      closeHelpDoc(){
          this.$emit('closeHelpVisible','')
      }
  },
};
</script>

<style scoped lang="scss">
.duanluo {
  text-indent: 2em;
}
p {
  line-height: 20px;
  span.right {
    float: right;
    margin-right: 20px;
  }
}
.help-content {
  padding: 15px;
}
</style>
